module.exports = __webpack_public_path__ + "static/media/TAD-Screenshot.293ea451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TAD-Screenshot.jpg
// module id = 71
// module chunks = 0